<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>

<div class="avatars-list">
    @for (user of users; track user.member.guid) {
        <div class="avatars-list-item">
            <div (click)="helper.openProfileByGuid(user.member.guid)" data-action="openProfile" class="avatars-list-item-data">
                <app-contract-avatar  [avatarSize]="'36px'" [userGuid]="user.member.guid"> </app-contract-avatar>
                <span class="avatars-list-item-data-text" 
                    [class.blocked_user]="user.member.project_setting.observation_type === 'blocked'" 
                    [class.inactive_user]="!user.member.is_active"
                    >
                        {{('TASKS.TEXT.TASK_ROLES.' + user.role)|translate}} : {{ helper.fullName(user.member) }}
                </span>
            </div>
            <button 
                (click)="deleteUser(user)" data-action="deleteUser"   
                [matTooltip] = "'TASKS.TOOLTIPS.DELETE_PARTY_FROM_TASK' | translate"   
                class="button-icon icononly size-m secondary-button">
                <mat-icon svgIcon="close-line"> </mat-icon>
            </button>
        </div>
    }
</div>